var TariffGroup = /*@__PURE__*/ (function () {
    function TariffGroup(data) {
        if (data.id) {
            this.id = parseInt(data.id, 10);
        }
        if (data.label) {
            this.label = data.label;
        }
        if (data.additional) {
            if (data.additional.sub20) {
                this.sub20 = data.additional.sub20 === 'true';
            }
            if (data.additional.subscriptionType) {
                this.subscriptionType = data.additional.subscriptionType;
            }
        }
        this.tariffs = [];
    }
    TariffGroup.prototype.addTariff = function (tariff) {
        this.tariffs.push(tariff);
        return this;
    };
    return TariffGroup;
}());
export { TariffGroup };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/tariff/tariff-group.ts
// module id = null
// module chunks = 